"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Alert = exports.AlertContent = exports.AlertTitle = exports.AlertIcon = void 0;
var React = __importStar(require("react"));
var Flex_1 = require("../Flex");
var Text_1 = require("../Typography/Text");
var View_1 = require("../View");
var icons_1 = require("../icons");
var styles_1 = require("./styles");
var AlertIcon = function (_a) {
    var children = _a.children;
    return (React.createElement(Flex_1.Flex, null, children));
};
exports.AlertIcon = AlertIcon;
var commonStyleProps = {
    color: 'n900',
    fontSize: 'fontsize16',
    lineHeight: 1.5,
};
var AlertTitle = function (_a) {
    var children = _a.children;
    return (React.createElement(Text_1.Text, __assign({ fontWeight: "semiBold" }, commonStyleProps),
        children,
        "\u00A0"));
};
exports.AlertTitle = AlertTitle;
exports.AlertTitle.defaultProps = {
    /**
     * This is used as an identifier when mapping over components passed as children into Alert.
     */
    __type: 'AlertTitle',
};
var AlertContent = function (_a) {
    var children = _a.children;
    return (React.createElement(Text_1.Text, __assign({}, commonStyleProps), children));
};
exports.AlertContent = AlertContent;
exports.AlertContent.defaultProps = {
    /**
     * This is used as an identifier when mapping over components passed as children into Alert.
     */
    __type: 'AlertContent',
};
// Define variant styles here
var variantStyles = {
    info: {
        color: 'blue500',
        Icon: icons_1.InfoCircleIcon,
    },
    error: {
        color: 'red500',
        Icon: icons_1.ErrorIcon,
    },
    success: {
        color: 'green500',
        Icon: icons_1.SuccessIcon,
    },
    suggestion: {
        color: 'n900',
        Icon: icons_1.SuggestionLightbulbIcon,
    },
    warning: {
        color: 'bronze400',
        Icon: icons_1.WarningIcon,
    },
};
var getVariantStyles = function (variant) {
    var Icon;
    var IconComponent = React.createElement(React.Fragment, null);
    var color = undefined;
    if (variant) {
        var styles = variantStyles[variant];
        Icon = styles.Icon;
        color = styles.color;
    }
    if (Icon)
        IconComponent = React.createElement(Icon, { size: "20px", color: color });
    return { IconComponent: IconComponent, color: color };
};
exports.Alert = React.forwardRef(function (_a, ref) {
    var props = __rest(_a, []);
    var _b = React.useState(true), visibleState = _b[0], setVisible = _b[1];
    var handleDismiss = function () {
        setVisible(!visibleState);
        if (props.dismissible && props.onClose) {
            props.onClose();
        }
    };
    var variantStyles = getVariantStyles(props.variant);
    var currentChildren = React.Children.toArray(props.children);
    var leftContent = currentChildren.filter(function (child) {
        return child.props.__type === 'AlertTitle' ||
            child.props.__type === 'AlertContent';
    });
    var rightContent = currentChildren.filter(function (child) { return child.props.__type === 'Button'; });
    var metadataGroup = currentChildren.filter(function (child) { return child.props.__type === 'Metadata'; });
    var alertIcon = currentChildren.filter(function (child) { return child.props.__type === 'Icon'; });
    var borderColor = props.borderColor || variantStyles.color;
    return (
    //@ts-expect-error The theme object is now too large for TS to represent its type here. TODO: Restrict to specific border colors when we next make breaking changes so we can remove this
    React.createElement(styles_1.AlertStyles, __assign({}, props, { visible: visibleState, ref: ref, role: "alert", "aria-live": "polite", borderColor: borderColor }),
        React.createElement(styles_1.InlineFlex, null,
            alertIcon.length > 0 ? alertIcon : variantStyles.IconComponent,
            React.createElement(styles_1.CollapsibleFlex, { id: "collapsible-flex", hasCTA: rightContent.length > 0, width: "100%" },
                React.createElement(View_1.View, { flex: "1" }, leftContent),
                React.createElement(styles_1.CTAFlexContainer, null,
                    " ",
                    metadataGroup,
                    " "),
                React.createElement(styles_1.CTAFlexContainer, null,
                    " ",
                    rightContent,
                    " ")),
            props.dismissible && (React.createElement(styles_1.CloseButtonFlexContainer, null,
                React.createElement(styles_1.PlainClickableButton, { onClick: handleDismiss, "aria-label": "Close" },
                    React.createElement(icons_1.CancelIcon, { color: "contentPrimary", size: "20px" })))))));
});
//# sourceMappingURL=index.js.map